<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box no-display" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong> All Subject Consolidated Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
            :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
            persistent-hint hint="Please select academic year" />
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
            item-text="display_name" item-value="id" label="Semester" persistent-hint hint="Please select semester"
            @click="putallnull()" />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
            :items="std_div_list" item-text="std" label="Standard" outlined @change="
              getDiv();
              getassessmentschemedetails();
            " persistent-hint hint="Please select standard" @click="putnull" />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id" :items="div_list"
            item-text="div_name" label="Division" outlined persistent-hint hint="Please select division" />
        </v-col>
        <v-col cols="12" sm="5" md="5" v-if="assessment_detail_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="assessment_detail" return-object
            :items="assessment_detail_list" item-text="assessmenttype" label="Assessment Scheme Details" outlined
            persistent-hint hint="Please select assessment scheme details" @click="putnull3" />
        </v-col>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name"
            item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && sel_std_data && div && assessment_detail">
          <v-btn class="mt-6 button" @click="getreport()" :loading="fetch_loader">Fetch</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <!-- <v-row justify="center"> -->
    <span v-if="learner_course_list != null">
      <span v-if="show">
        <v-row>
          <v-col cols="12" sm="3" md="3">
            <!-- <v-btn
              class="ma-2 no-display"
              tile
              outlined
              color="warning"
              @click="CartPdf()"
            >
              <v-icon left>mdi-printer</v-icon> Print</v-btn
            > -->
            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
              <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-btn class="no-display" rounded color="success" outlined
              @click="fnExcelReport('tab1', 'AllSubjectReport')" :loading="loader"><v-icon
                color="success">mdi-export</v-icon>Export</v-btn>
          </v-col>
        </v-row>

        <!-- new header code by shiv -->

        <!-- <div id="tab" v-if="org_basic_data">
            <v-row dense justify="center">
              <v-col
                cols="12"
                sm="4"
                md="2"
                v-if="org_basic_data.trust_logo"
                align="center"
              >
                <img
                  :src="org_basic_data.trust_logo"
                  alt="logo"
                  class="trust-logo"
                />
              </v-col>
              <v-col cols="12" sm="4" md="8">
                <center>
                  <h2>
                    <strong>{{ org_basic_data.trust_name }}</strong>
                  </h2>
                  <h3>
                    <strong>{{ org_basic_data.school_name }} </strong>
                  </h3>
                  <span>
                    {{ ass_Scheme }} ({{ academicyear }}) Consolidated
                    Sheet</span
                  >
                  <br />
                  <span>
                    <strong> Class : {{ standard }} {{ division }} </strong>

                    <strong>Exam : {{ ass_Scheme }}</strong>
                  </span>
                </center>
              </v-col>
              <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo">
                <img
                  :src="org_basic_data.school_logo"
                  alt="logo"
                  class="schl-logo"
                />
              </v-col>
            </v-row>
          </div> -->

        <!-- shiv code end -->

        <div id="tab">
          <table style="width: 100%; border-collapse: collapse; border: none;">
            <thead style="border: none;">
              <tr style="vertical-align: middle; border: none;">
                <!-- Left Logo -->
                <th style="width: 20%; text-align: left; padding-left: 25px; border: none;">
                  <img v-if="org_basic_data.trust_logo" :src="org_basic_data.trust_logo" alt="Trust Logo"
                    style="height: 150px;" />
                </th>

                <!-- Center Text -->
                <th style="width: 60%; text-align: center; line-height: 1.5; border: none;">
                  <h2 style="margin: 0; font-size: 26px; font-weight: 700;">
                    {{ org_basic_data.trust_name }}
                  </h2>
                  <h3 style="margin: 0; font-size: 22px; font-weight: 600;">
                    {{ org_basic_data.school_name }}
                  </h3>
                  <h5 style="margin: 6px 0 0 0; font-size: 17px; font-weight: 500;">
                    {{ ass_Scheme }} ({{ academicyear }}) Consolidated Sheet
                  </h5>
                </th>

                <!-- Right Logo -->
                <th style="width: 20%; text-align: right; padding-right: 25px; border: none;">
                  <img v-if="org_basic_data.school_logo" :src="org_basic_data.school_logo" alt="School Logo"
                    style="height: 150px;" />
                </th>
              </tr>

              <!-- Class / Division / Exam Row -->
              <tr style="border: none;">
                <th colspan="3" style="text-align: center; padding-top: 12px; border: none;">
                  <h4 style="margin: 0; font-size: 19px; font-weight: 600;">
                    Class : {{ standard }} |
                    Div :
                    <span v-for="(header, index) in division" :key="index">
                      {{ index + 1 }}) {{ header }}
                    </span>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    Exam : {{ ass_Scheme }}
                  </h4>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div id="tab1">
          <div class="">
            <v-simple-table fixed-header dense class="elevation-1 scroll table-data">
              <thead>
                <tr>
                  <th class="">
                    <center>Sr. No.</center>
                  </th>
                  <th class="">
                    <center>Roll No.</center>
                  </th>
                  <th class="">
                    <center>Registration No.</center>
                  </th>
                  <th class="">
                    <center>Name</center>
                  </th>
                  <th class="">
                    <center>Division</center>
                  </th>
                  <th class="" v-for="header in course_list" :key="header">
                    <center>{{ header }}</center>
                  </th>
                  <!-- <th class="" v-for="header in atotal" :key="header">
                                    <center>Total {{ header }}</center>
                                </th>
                               <th class="" v-for="header in ass_converted_total" :key="header">
                                    <center>{{ header }}</center>
                                </th>  -->
                  <!--<th><center>{{ass_detail_list[0]}}}</center></th>  -->
                  <th>
                    <center>Total ({{ atotal[0] }})</center>
                  </th>
                  <th>
                    <center>
                      <!--{{ass_converted_total[0]}}-->
                      %
                    </center>
                  </th>
                  <th class="">
                    <center>Grade</center>
                  </th>
                </tr>
              </thead>
              <tbody style="overflow-y: scroll; border: 1px solid #ccc">
                <tr v-for="(s, index) in learner_course_list" :key="s.cid">
                  <td>{{ index + 1 }}</td>
                  <td>{{ s.rollno }}</td>
                  <td>
                    {{ s.registration_number }}
                  </td>
                  <td>{{ s.name }}</td>
                  <td>
                    {{ s.division }}
                  </td>
                  <td v-for="(header, index) in s.comp_marks" :key="index">
                    <center>{{ header }}</center>
                  </td>
                  <td>
                    <center>{{ s.levaluated_marks }}</center>
                  </td>
                  <td>
                    <center>{{ s.converted_marks }}</center>
                  </td>
                  <td>
                    <center>{{ s.grade }}</center>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <br /><br /><br /><br /><br />
            <!-- Add a new row-like structure below the table -->
            <v-row dense class="mt-8" style="width: 100%; align-items: center;">
              <!-- Left: Subject Teacher -->
              <v-col cols="4" class="text-left" style="padding-left: 40px;">
                <strong>Subject Teacher</strong>
              </v-col>

              <!-- Center: Exam Incharge -->
              <v-col cols="4" class="text-center">
                <strong>Exam Incharge</strong>
              </v-col>

              <!-- Right: Principal -->
              <v-col cols="4" class="text-right" style="padding-right: 40px;">
                <strong>Principal</strong>
              </v-col>
            </v-row>
          </div>
        </div>
        <!-- </v-col> -->
      </span>
    </span>
    <!-- </v-row> -->
    <!-- </v-card> -->
  </div>
</template>
<script>
  import axios from "axios";
  import jsPDF from "jspdf";
  import "jspdf-autotable";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
    data() {
      return {
        overlay: false,
        selected: [],
        snackbar: false,
        course_list: [],
        crs_id: null,
        search: "",
        crs_list: [],
        snackbar_msg: "",
        color: "",
        snackbar: false,
        ay_std_div_list: null,
        sel_ay_data: null,
        std_div_list: null,
        sel_std_data: null,
        div_list: null,
        div: null,
        semester_list: null,
        sem: null,
        fetch_loader: false,
        assessment_detail_list: [],
        assessment_detail: [],
        standard: null,
        division: null,
        course: null,
        ass_Scheme: null,
        academicyear: null,
        ass_detail_list: null,
        learner_course_list: null,
        inst_name: null,
        atotal: null,
        ass_converted_total: null,
        show: false,
        course_list: [],
        org_basic_data: [],
        default_value: null,
        status_list: [
          { name: "Active", id: "0" },
          { name: "Temporary Inactive", id: "1" },
          { name: "Permanent Inactive", id: "2" },
        ],
        status: null,
      };
    },

    methods: {
      fnExcelReport(id, name) {
        var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
        tab_text =
          tab_text +
          "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
        tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
        tab_text =
          tab_text +
          "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
        tab_text =
          tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
        tab_text = tab_text + "<table border='1px'>";
        var exportTable = $("#" + id).clone();
        exportTable.find("input").each(function (index, elem) {
          $(elem).remove();
        });
        tab_text = tab_text + exportTable.html();
        tab_text = tab_text + "</table></body></html>";
        var fileName =
          name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

        //Save the file
        // var blob = new Blob([tab_text], {
        //   type: "application/vnd.ms-excel;charset=utf-8",
        // });
        // window.saveAs(blob, fileName);
        const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const filename = name + '.xls';

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // For IE
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          // For modern browsers
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      },

      putallnull() {
        this.div_list = null;
        (this.assessment_detail_list = []), (this.assessment_detail = null);
      },
      putnull3() {
        this.show = false;
      },
      print() {
        this.$store.state.drawer = false;
        let that = this;
        window.onafterprint = function () {
          that.$store.state.drawer = true;
        };
        setTimeout(function () {
          window.print();
        }, 100);
      },
      putnull() {
        this.crs_list = [];
        this.crs_id = null;
      },
      putnull2() {
        (this.assessment_detail_list = []), (this.assessment_detail = null);
      },
      getassessmentschemedetails() {
        const data = {
          ay: this.sel_ay_data.ay_id,
          standard: this.sel_std_data.std_id,
          sem: this.sem,
        };
        axios
          .post("/Examination/getassschemedetails", data)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.assessment_detail_list = res.data.assessment_detail_list;
            }
            if (res.data.flag == "NO") {
              this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          })
          .finally(() => { });
      },
      getreport() {
        const data = {
          ay: this.sel_ay_data.ay_id,
          standard: this.sel_std_data.std_id,
          sem: this.sem,
          div: this.div,
          assessment_detail: this.assessment_detail.id,
          status: this.status,
        };
        this.fetch_loader = true;
        axios
          .post("/Examination/getallsubjectconsolidatedreport", data)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.standard = res.data.standard;
              this.division = res.data.div;
              this.course = res.data.course;
              this.ass_Scheme = res.data.ass_Scheme;
              this.academicyear = res.data.ay;
              this.learner_course_list = res.data.learner_course_list;
              this.default_value = res.data.default_value;
              if (this.default_value == "True") {
                for (var i = 0; i < this.learner_course_list.length; i++) {
                  this.learner_course_list[i].converted_marks = Math.round(
                    this.learner_course_list[i].converted_marks
                  );
                  this.learner_course_list[i].levaluated_marks = Math.round(
                    this.learner_course_list[i].levaluated_marks
                  );
                }
              }
              this.course_list = res.data.course_list;
              this.inst_name = res.data.inst_name;
              this.atotal = res.data.atotal;
              this.ass_converted_total = res.data.ass_converted_total;
              this.org_basic_data = res.data.org_basic_data;
              this.fetch_loader = false;
              this.show = true;
            }
            if (res.data.flag == "NO") {
              this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
              this.fetch_loader = false;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            this.fetch_loader = false;
          })
          .finally(() => { });
      },
      getStd() {
        this.std_div_list = null;
        this.sel_std_data = null;
        this.div_list = null;
        this.div = null;
        this.std_div_list = this.sel_ay_data.std_list;
      },
      getDiv() {
        this.div_list = ["All"];
        this.div = "All";
        this.div_list = this.sel_std_data.div_list;
        this.div_list.unshift("All");
        this.div = this.div_list[0];
        if (this.div_list.length == 0) {
          alert("No division found!!!");
          this.div_list = null;
        }
      },
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
      onload() {
        axios
          .post("/commonAPI/get_ay_std_div")
          .then((res) => {
            this.ay_std_div_list = res.data.data;
            //     this.sel_ay_data = res.data.curr_ay;
            this.semester_list = res.data.sem_list;
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          })
          .finally(() => { });
      },
      CartPdf() {
        var tab = document.getElementById("tab");
        var tab1 = document.getElementById("tab1");
        var win = window.open("", "", "height=700,width=1000");
        win.document.write(tab.outerHTML, tab1.outerHTML);
        win.document.close();
        win.print();
      },
    },
    mounted() {
      this.onload();
    },
  };
</script>
<style scoped>
  .table {
    border: none !important;
  }

  .scroll {
    overflow-x: scroll;
  }

  tr,
  td,
  th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
  }

  tr,
  tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
  }

  td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
  }

  .table-data >>> .v-data-table__wrapper {
    height: 500px;
    overflow-y: auto;
  }

  .table-data >>> thead th {
    position: sticky !important;
    top: 0 !important;
    z-index: 3 !important;
    background: #fff !important;
  }

  @media (min-width: 320px) {

    td,
    th {
      display: table-cell !important;
      font-size: small;
    }

    td+td,
    th+th {
      width: auto;
      font-size: small;
    }
  }

  v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
  }

 @media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  table,
  td,
  tr {
    break-inside: avoid-page;
  }

  .scroll {
    overflow-x: hidden;
  }

  body,
  tr,
  th,
  td {
    font-size: small !important;
    font-weight: bold !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  v-card {
    border: none !important;
  }

  .trust-logo {
    width: 40%;
  }

  .schl-logo {
    width: 40%;
  }

  @page {
    size: A4;
    margin: 0px;
    size: 20in 15in;
  }

  .table-data {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .table-data >>> .v-data-table__wrapper {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .table-data >>> thead th {
    position: static !important;
  }
}

  /* .trust-logo {
  width: 41%;
} */
  .trust-logo {
    width: 40%;
  }

  .schl-logo {
    width: 40%;
  }

  .table-data {
    height: 500px;
  }
</style>